import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
@Entity('link_types')

export class LinkTypesEntity {

    @PrimaryGeneratedColumn('increment',{name:'id'}) Id: number;
    @Column({
        type: 'varchar',
        nullable: true,
        length: '500',
        name: 'title',
    })
    title: string;
    @Column("boolean",{
        nullable:false,
        default:true,               
        name:"status"
    })
    status:boolean;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;   
}